/* eslint-disable */
import React, { Component } from "react";
import classnames from "classnames";

import "./DropDownSelect.css";
import DisplayError from "../DisplayError/DisplayError";
import wrapperComponent from "../WrapperComponent/WrapperComponent";
import Tooltip from '../Tooltip';
import PersistLink from '../PersistLink';

class DropDownSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.optionIdKey || "id",
      displayKey: this.props.optionDisplayKey || [[]],
      selectedOption: this.props.selectedValue,
      availableOptions: this.props.options || [],
      disabledOptions: this.props.disabledOptionsId || [],
      expanded: false,
      dropDownHeading: this.props.dropDownHeading || '',
      placeHolder: this.props.placeHolder || "Please Select",
      editable: this.props.editable || false,
      required: this.props.required || false,
      errorString: "",
      showTooltip: false,
      randomIdx: Math.random().toString(36).slice(2)
    };
  }
  static getClassName() { return 'DropDownSelect' };


  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedOption: nextProps.selectedValue,
      availableOptions: nextProps.options || [],
      disabledOptions: nextProps.disabledOptionsId || [],
      editable: nextProps.editable || false,
      placeHolder: nextProps.placeHolder || "Please Select"
    });
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  getEditableFlag = (currValue, options) => {
    let editableItem = false;
    for (let item of options) {
      if (currValue === item[this.props.optionIdKey] && item['otherAccount']) {
        editableItem = true;
        break;
      }
    }
    return editableItem;
  }

  handleClickOutside = (event) => {
    if (this.dropDownContentRef && !this.dropDownContentRef.contains(event.target) && this.state.expanded) {
      this.setState({
        errorString: "",
        expanded: false
      })
    }
  }

  toggleOptionDisplay = () => {
    this.setState({
      errorString: "",
      expanded: !this.state.expanded
    });
  };

  toggleTooltip = () => {
    var selector = `[data-tooltip=${this.props.name + this.state.randomIdx}]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }

  selectOption = id => e => {
    this.setState({
      errorString: "",
      expanded: !this.state.expanded
    });
    if (id !== undefined && id.trim() !== '') {
      this.restoreFocus();
    } else {
      this.toggleOptionDisplay();
    }
    let eventObject;
    if (this.props.simpleDropDown) {
      let _displaykey = this.state.displayKey[0][0] || 'name';
      let _selectedObj = this.state.availableOptions.map(item => {
        if (item.id === e.target.value) {
          return { name: item[_displaykey], value: e.target.value };
        }
      })
        .filter(item => item);
      eventObject = {
        updateValue: _selectedObj[0],
        type: 'dropDownSelectOperation',
        dataSourceKey: this.props.dataSourceKey,
        idx: this.props.repeatComponentIdx
      }
    } else {
      eventObject = {
        currentValue: this.state.selectedOption,
        updateValue: id,
        type: 'dropDownSelectOperation',
        dataSourceKey: this.props.dataSourceKey,
        disbaledOptionKey: this.props.disbaledOptionKey,
        idx: this.props.repeatComponentIdx
      }
    }
    if ((this.props.dataSourceKey === "availableContacts" || this.props.dataSourceKey) && this.props.name === "securityId" && (eventObject.idx === -1)) {
      eventObject.idx = 0
    }
    return this.props.onSelect(eventObject);
  };

  handleEdit = e => {
    if (this.state.selectedOption && this.state.selectedOption.trim !== "") {
      let editObject = this.state.availableOptions.filter(
        item => item[this.state.id] === this.state.selectedOption
      );
      editObject[0].editLink = this.props.editLink
      this.props.onEdit(editObject);
    } else {
      e.stopPropagation();
    }
    if (this.state.errorString.trim() !== "") {
      this.setState({
        errorString: ""
      });
    }
    if (this.props.persistDataStore && typeof this.props.persistDataStore === 'object') {
      const dropDownData = JSON.stringify({ ...this.props.persistDataStore })
      if (this.props.setCurrentDropDownSelect) {
        this.props.setCurrentDropDownSelect(dropDownData)
      }
    } else {
      if (this.props.resetCurrentDropDownSelect) {
        this.props.resetCurrentDropDownSelect()
      }
    }
  };

  restoreFocus = () => {
    this.dropDownDisplay.focus();
  };

  handleBlur = () => {
    //this.props.onBlur();
    this.setState({
      errorString: this.props.customErrorMessage || "Please select a value"
    });
  };

  isUpperCaseAt = (str, index) => {
    return str.charAt(index).toUpperCase() === str.charAt(index);
  }

  createDisplayString = opt => {
    let displayString = "";
    let i = -1;
    if (opt.defaultKey) {
      displayString += opt.displayKey;
    } else {
      for (let item of this.state.displayKey) {
        i = i + 1;
        for (let lineItem of item) {
          //for starts

          let splitForSpaces = lineItem.split(':');
          if (splitForSpaces.length > 1) {
            let _isString = false;
            for (let spaceItem of splitForSpaces) {
              let splitLineItem = spaceItem.split('.');
              if (splitLineItem.length > 1) {
                let displayPart = opt[splitLineItem[0]] || undefined;
                if (displayPart) {
                  for (let p = 1; p < splitLineItem.length; p++) {
                    if (displayPart) {
                      displayPart = displayPart[splitLineItem[p]] || undefined;
                      if (splitLineItem[p] === 'name' && displayPart === 'Other') {
                        displayPart = opt[displayPart.toLowerCase()] || undefined;
                      }
                    } else {
                      break;
                    }
                  }
                }
                displayString +=
                  displayPart && displayPart.trim() !== ""
                    ? `${displayPart} `
                    : "";
                if (displayPart && displayPart.trim() !== "") {
                  _isString = true;
                }
              } else {
                //Checking the first character of splitLineItem[0] for upper case as same is not a key of object but
                //static text that needs to be appended as it is -> e.g. 'Tel:telephone' -> ['Tel','telephone'] -> splitLineItem[0] is 'Tel' (not part of object key)
                if (!opt[splitLineItem[0]] && this.isUpperCaseAt(splitLineItem[0], 0)) {
                  //Also check for this label's (e.g. 'Tel') value (e.g. 'telephone') in object.
                  // If not present then label should not be shown.
                  if (opt[splitForSpaces[1]] && opt[splitForSpaces[1]].trim() !== "") {
                    displayString += `${splitLineItem[0]}: `,
                      _isString = true;
                  }
                } else {
                  displayString +=
                    typeof opt[splitLineItem[0]] === 'string' && opt[splitLineItem[0]] && opt[splitLineItem[0]].trim() !== ""
                      ? `${opt[splitLineItem[0]]} `
                      : "";
                  if (typeof opt[splitLineItem[0]] === 'string' && opt[splitLineItem[0]] && opt[splitLineItem[0]].trim() !== "") {
                    _isString = true;
                  }
                }
              }
            }
            if (displayString && displayString.trim() !== '' && _isString) {
              displayString = displayString.trim() + ',';
            }
          } else {
            let splitLineItem = lineItem.split('.');
            if (splitLineItem.length > 1) {
              let displayPart = opt[splitLineItem[0]] || undefined;
              if (displayPart) {
                for (let p = 1; p < splitLineItem.length; p++) {
                  if (displayPart) {
                    displayPart = displayPart[splitLineItem[p]] || undefined;
                    if (splitLineItem[p] === 'name' && displayPart === 'Other') {
                      displayPart = opt[displayPart.toLowerCase()] || undefined;
                    } else if (splitLineItem[0] === 'country' && (typeof opt['newEchannel'] === "boolean")) {
                      //This check appends New and Existing tags to eChannels e.g. in dropdown display
                      if (opt['newEchannel']) {
                        displayPart += ` (New)`;
                      } else {
                        displayPart += ` (Existing)`;
                      }
                    }
                  } else {
                    break;
                  }
                }
              }
              displayString +=
                displayPart && displayPart.trim() !== ""
                  ? `${displayPart},`
                  : "";
            } else {
              displayString +=
                opt[lineItem] && opt[lineItem].trim() !== ""
                  ? `${opt[lineItem]},`
                  : "";
            }
          }

          //for ends
        }

        //remove the trailing comma(if any)
        if (displayString.trim().substr(-1) === ",") {
          displayString = displayString.substring(0, displayString.length - 1);
        }
        if (
          i < this.state.displayKey.length - 1 &&
          displayString.slice(-5) !== "<br/>"
        ) {
          if (i === 0) {
            displayString = "<b>" + displayString + "</b>" + "<br/>";
          }
          else {
            if (displayString.trim() !== "") {
              displayString += "<br/>";
            }
          }
        }
      }
    }
    return { __html: displayString };
  };

  renderDisplayString = opt => {
    let dropDownDisplayCss = classnames({
      "gdocs-dropdown-display-string-without-tooltip": !this.props.tooltip,
      "gdocs-dropdown-display-string-with-tooltip": this.props.tooltip
    })
    if (
      this.state.displayKey &&
      this.state.displayKey.length > 0 &&
      this.state.displayKey[0].length > 0
    )
      return <div dangerouslySetInnerHTML={this.createDisplayString(opt)} className={dropDownDisplayCss} />;
    else return <div dangerouslySetInnerHTML={this.state.placeHolder || 'Please Select'} />;
  };

  handleEnterKey = e => {
    if (e.which === 13 || e.keyCode === 13) {
      return true;
    } else {
      return false;
    }
  };

  handleEscapeKey = e => {
    this.toggleOptionDisplay();
    this.restoreFocus();
  };

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=${this.props.name + this.state.randomIdx}]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: false
      })
    }
  }

  getDefaultDisplayString = () => {
    let defaultDisplayObject = {};
    for (let item of this.state.availableOptions) {
      if (item[this.state.id] === this.state.selectedOption) {
        defaultDisplayObject = item;
        break;
      }
    }
    if (Object.keys(defaultDisplayObject).length > 0) {
      if (this.state.editable && (!defaultDisplayObject['otherAccount'] && !defaultDisplayObject['firstName'] && !defaultDisplayObject['addressLine1'])) {
        this.setState({
          editable: false
        });
      }
    }
    return this.renderDisplayString(defaultDisplayObject);
  };

  renderOptionsList = () => {
    if (this.state.availableOptions.length <= 0) {
      return "";
    } else {
      if (
        this.state.displayKey &&
        this.state.displayKey.length > 0 &&
        this.state.displayKey[0].length > 0
      ) {
        let _displayOptions;
        let defaultDisplayOption = {
          [this.state.id]: '',
          displayKey: this.state.placeHolder || "Please Select",
          defaultKey: true
        }
        if (!this.props.repeatingField) {
          _displayOptions = [defaultDisplayOption, ...this.state.availableOptions];
        } else {
          if (this.props.name.split('_')[0] === 'securityId' || this.props.name.split('_')[0] === 'contactId') {
            _displayOptions = [defaultDisplayOption, ...this.state.availableOptions];
          } else {
            _displayOptions = [...this.state.availableOptions];
          }

        }
        return (
          <ul className="gdocs-single-line-select-container__list">
            {_displayOptions.map((option, idx) => {
              let listOptionCss = classnames(
                "gdocs-single-line-select-container__list_item",
                {
                  "gdocs-single-line-select-container__list_item_disabled":
                    this.state.selectedOption === option[this.state.id] || this.state.disabledOptions.includes(option[this.state.id])
                }
              );
              return (
                <li
                  key={idx}
                  className={listOptionCss}
                  onClick={
                    this.state.selectedOption !== option[this.state.id] && !this.state.disabledOptions.includes(option[this.state.id])
                      ? this.selectOption(option[this.state.id])
                      : e => {
                        e.stopPropagation();
                      }
                  }
                  onKeyUp={e => {
                    if (this.handleEnterKey(e)) {
                      return this.state.selectedOption !== option[this.state.id] && !this.state.disabledOptions.includes(option[this.state.id])
                        ? this.selectOption(option[this.state.id])()
                        : e => {
                          this.setState({
                            expanded: !this.state.expanded
                          });
                          e.stopPropagation();
                        };
                    } else {
                      if (e.which === 27 || e.keyCode === 27) {
                        this.handleEscapeKey();
                      }
                      e.stopPropagation();
                    }
                  }}
                >
                  {this.renderDisplayString(option)}
                </li>
              );
            })}
          </ul>
        );
      } else {
        return "";
      }
    }
  };

  renderSimpleDropDown = () => {
    const simpleDropDownLabelClass = classnames({
      "gdocs-simple-drop-down-select-form-label-column": this.props.repeatingField === false ? true : false,
      "gdocs-simple-drop-down-select-form-label-embedded-column": this.props.repeatingField === true ? true : false
    })
    let chevronCss = classnames({ "drop-down-toggle-icon": true });
    let editableIconCss = classnames("icon", { "icon-edit-selection-hide": true });
    // "icon-edit-selection-hide": this.state.editable
    //   ? (this.state.selectedOption !== undefined && this.state.selectedOption.trim() !== ""
    //     ? false
    //     : true
    //     )
    //   : true
    // });
    let dropDownOptionCss = classnames({
      "dropdown-option-default": true
    });
    let simpleDropdownCss = classnames("gdocs-simple-dropdown-container");
    let _displayKey = this.state.displayKey[0][0] || 'name';
    let defaultOption = {
      [this.state.id]: undefined,
      [_displayKey]: this.state.placeHolder || "Please Select",
      disabled: this.props.required
    }
    let options = [defaultOption, ...this.state.availableOptions];
    return (
      <div className="gdocs-simple-drop-down-select-form-row">
        {this.props.label ? (
          <div className={simpleDropDownLabelClass}>
            <label htmlFor={this.props.name + "_"}>{this.props.label}</label>
          </div>
        ) : (
          ""
        )}
        <div className="gdocs-drop-down-select-form-content-column">
          <div className={simpleDropdownCss}>
            <div className="dropdown-arrow-chevron">
              <span
                className={editableIconCss}
                style={{ cursor: "pointer", marginRight: "5px" }}
                onClick={this.handleEdit}
              >
                &#128393;
              </span>
              <span className="vertical-line">|</span>
              <span
                className={chevronCss}
              >
                <i className="icon icon-chevron-down"></i>
              </span>
            </div>
            <select
              className="gdocs-simple-dropdown"
              name={`dropDownSelect`}
              value={this.state.selectedOption}
              onChange={this.selectOption()}
              id={this.props.name + "_"}
            >
              {options.map((item, index) => (
                <option
                  key={index}
                  value={item[this.state.id]}
                  disabled={item.disabled || this.state.selectedOption === item[this.state.id]}
                  className={dropDownOptionCss}
                >
                  {item[_displayKey]}
                </option>
              ))}
            </select>
          </div>
        </div>
        {this.props.tooltip ? (
          <div>
            <button type="button" data-toggletip-content={this.props.tooltip}
              className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
              data-tooltip={this.props.name + this.state.randomIdx}
              aria-expanded={false}
              aria-describedby={`${this.props.name + this.state.randomIdx}tooltip`}
              onMouseEnter={this.toggleTooltip}
              onMouseLeave={this.toggleTooltip}
              onClick={this.toggleTooltip}
              onKeyUp={(event) => this.toggleTooltiponEnter(event)}
              aria-label={`Additional Information on ${this.props.label}`}>
            </button>
            <Tooltip
              active={this.state.showTooltip}
              position="right"
              arrow="center"
              parent={this.props.name + this.state.randomIdx}
            >
              <div className="tooltip-content-hintText" >
                <span role="status" id={`${this.props.name + this.state.randomIdx}tooltip`}>{this.props.tooltip}</span>
              </div>
            </Tooltip>
          </div>
        ) : ('')
        }
      </div>
    );
  };

  render() {
    if (this.props.simpleDropDown) {
      return this.renderSimpleDropDown();
    } else {
      let isMultiSelect = this.state.displayKey.length > 1 ? true : false;
      const dropDownBoxDivClass = classnames("drop-down-box-div", { "drop-down-box-div-multiselect": isMultiSelect });
      const dropDownEditIconClass = classnames("drop-down-edit-icon", { "drop-down-edit-icon-multiselect": isMultiSelect });
      const dropDownSeparatorClass = classnames({ "drop-down-separator-icon-multiselect": isMultiSelect });
      const dropDownArrowClass = classnames("drop-down-toggle-icon", { "drop-down-toggle-icon-multiselect": isMultiSelect });
      const dropDownLabelClass = classnames({
        "gdocs-drop-down-select-form-label-column": this.props.repeatingField === false ? true : false,
        "gdocs-drop-down-select-form-label-embedded-column": this.props.repeatingField === true ? true : false
      })
      if (this.state.availableOptions.length <= 0) {
        return (
          <div className="gdocs-drop-down-select-form-row" id={this.props.key}>
            {this.props.label ? (
              <div className={dropDownLabelClass}>
                <label for={this.props.label}>{this.props.label}</label>
              </div>
            ) : (
              ""
            )}
            <div className="gdocs-drop-down-select-form-content-column">
              {this.props.linkTo ? (
                Object.keys(this.props.linkTo).length > 0 ? (
                  <div className="gdocs-drop-down-select-add-item">
                    <PersistLink
                      history={this.props.history}
                      to={this.props.linkTo.link}
                      state={this.props.stateData}
                      data={this.props.persistDataStore || ''}
                      style={{
                        textDecoration: "none",
                        color: "black",
                        marginLeft: "5px"
                      }}
                      setCurrentDropDownSelect={this.props.setCurrentDropDownSelect}
                      resetCurrentDropDownSelect={this.props.resetCurrentDropDownSelect}
                      currentDropDown={this.props.currentDropDown}
                    >
                      {this.props.linkTo.title}
                    </PersistLink>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </div>
          </div>
        )
      }
      else {
        return (
          <div className="gdocs-drop-down-select-form-row" id={this.props.name + this.state.randomIdx}>
            {this.props.label ? (
              <div className={dropDownLabelClass}>
                <label for={this.props.label}>{this.props.label}</label>
              </div>
            ) : (
              ""
            )}

            <div className="gdocs-drop-down-select-form-content-column" ref={(node) => { this.dropDownContentRef = node }}>
              <div
                className="drop-down-main-div"
              >
                <div
                  tabIndex="0"
                  className={dropDownBoxDivClass}
                  id={this.props.label + this.state.randomIdx}
                  onKeyUp={e => {
                    if (this.handleEnterKey(e)) {
                      this.toggleOptionDisplay();
                    } else {
                      if (e.which === 27 || e.keyCode === 27) {
                        this.handleEscapeKey();
                      }
                      e.stopPropagation();
                    }
                  }}
                >
                  <div className="drop-down-display-div">
                    {this.state.dropDownHeading
                      ? (<div><b style={{ color: 'gray' }}>{this.state.dropDownHeading}</b></div>)
                      : ('')}
                    {this.state.selectedOption
                      ? (<div>{this.getDefaultDisplayString()}</div>)
                      : (<div>{this.state.placeHolder}</div>)}
                  </div>
                  <div className="drop-down-icon-div">
                    {this.state.editable
                      && this.state.selectedOption ? (
                      <span
                        tabIndex="0"
                        className={dropDownEditIconClass}
                        onKeyUp={e => {
                          if (this.handleEnterKey(e)) {
                            this.handleEdit();
                            e.stopPropagation();
                          }
                        }}
                        onClick={this.handleEdit}
                      >
                        <b><i className="icon icon-edit"></i></b>
                      </span>
                    ) : (
                      ""
                    )}
                    <span className={dropDownSeparatorClass}>|</span>
                    <span
                      className={dropDownArrowClass}
                      onClick={this.toggleOptionDisplay}
                      onKeyUp={e => {
                        if (this.handleEnterKey(e)) {
                          this.toggleOptionDisplay();
                        }
                      }}
                      ref={displayDiv => {
                        this.dropDownDisplay = displayDiv;
                      }}
                    >
                      {this.state.expanded ? <i className="icon icon-chevron-up"></i> : <i className="icon icon-chevron-down"></i>}
                    </span>
                  </div>
                </div>

                {this.state.errorString.trim() !== "" ? (
                  <DisplayError color="red" errorText={this.state.errorString} />
                ) : (
                  ""
                )}

                <div className="drop-down-option-list-div">
                  {this.state.expanded ? this.renderOptionsList() : ""}
                </div>

                {this.props.linkTo ? (
                  Object.keys(this.props.linkTo).length > 0 ? (
                    <div className="gdocs-drop-down-select-add-item">
                      <PersistLink
                        history={this.props.history}
                        to={this.props.linkTo.link}
                        state={this.props.stateData}
                        data={this.props.persistDataStore || ''}
                        style={{
                          textDecoration: "none",
                          color: "black",
                          marginLeft: "5px"
                        }}
                        setCurrentDropDownSelect={this.props.setCurrentDropDownSelect}
                        resetCurrentDropDownSelect={this.props.resetCurrentDropDownSelect}
                        currentDropDown={this.props.currentDropDown}
                      >
                        {this.props.linkTo.title}
                      </PersistLink>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
            {this.props.tooltip ? (
              <div>
                <button type="button" data-toggletip-content={this.props.tooltip}
                  className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
                  data-tooltip={this.props.name + this.state.randomIdx}
                  aria-expanded={false}
                  aria-label={`Additional Information on ${this.props.label}`}
                  aria-describedby={`${this.props.name + this.state.randomIdx}tooltip`}
                  onMouseEnter={this.toggleTooltip}
                  onMouseLeave={this.toggleTooltip}
                  onClick={this.toggleTooltip}
                  onKeyUp={(event) => this.toggleTooltiponEnter(event)}>
                </button>
                <Tooltip
                  active={this.state.showTooltip}
                  position="right"
                  arrow="center"
                  parent={this.props.name + this.state.randomIdx}
                  id={`${this.props.name + this.state.randomIdx}tooltip`}
                >
                  <div className="tooltip-content-hintText">
                    <span role="status" id={`${this.props.name + this.state.randomIdx}tooltip`}>{this.props.tooltip}</span>
                  </div>
                </Tooltip>
              </div>
            ) : ('')
            }
          </div>
        );
      }

    }

  }
}

const WrappedDropDownSelect = wrapperComponent(DropDownSelect);
export default WrappedDropDownSelect;



// WEBPACK FOOTER //
// ./src/components/common/DropDownSelect/DropDownSelect.js